import { MaxWidthWrapper } from "@/components/maxWidthWrapper";
import { PricingCard } from "./pricingCard";
import { ApiCard } from "./apiCard";
import { IndustriesCard } from "./industriesCard";

export const Features = () => (
  <div className="w-full bg-secondary py-10 text-secondary-foreground md:py-36">
    <MaxWidthWrapper>
      <div className="mx-auto max-w-7xl">
        <div className="text-3xl font-semibold sm:text-4xl md:text-5xl">API and Pricing</div>
        <div className="py-6 text-lg/8 text-secondary-foreground">
          Flash's seamless API integration will have you up and running in no time.
        </div>
        <CardGrid />
      </div>
    </MaxWidthWrapper>
  </div>
);

const CardGrid = () => (
  <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
    <div className="lg:col-span-1">
      <PricingCard />
    </div>
    <div className="space-y-4 lg:col-span-2">
      <ApiCard />
      <IndustriesCard />
    </div>
  </div>
);
